import WDCSQRCODE from '@/assets/images/provincial/wdcs_qrcode.svg'

export default{
	name : 'qrcode_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {
			imgSrc: WDCSQRCODE,
			title: '长按图片识别小程序'
		}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		menuClick(item) {
			window.location.href = item.url
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/qrcode_dialog/js/detail.js